// extracted by mini-css-extract-plugin
module.exports = {"product-brief-guide":"BriefGuide_product-brief-guide__dx_lX"};